export const REQUIREMENTS_INDEX__SET_ALL = 'REQUIREMENTS_INDEX__SET_ALL';
export const REQUIREMENTS_INDEX__ADD_RESOURCE = 'REQUIREMENTS_INDEX__ADD_RESOURCE';
export const REQUIREMENTS_INDEX__UPDATE_RESOURCE = 'REQUIREMENTS_INDEX__UPDATE_RESOURCE';
export const REQUIREMENTS_INDEX__REMOVE_RESOURCE = 'REQUIREMENTS_INDEX__REMOVE_RESOURCE';
export const REQUIREMENTS_INDEX__CLEAR_ALL = 'REQUIREMENTS_INDEX__CLEAR_ALL';
